import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import Home from '@/pages/Home';
import Principals from '@/pages/Principals';
import Legal from '@/pages/Legal';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import ScrollToTop from '@/components/layout/ScrollToTop';
import Aviation from '@/pages/ventures/Aviation';
import EphemeraFoundation from '@/pages/ventures/Ephemera-foundation';
import RealEstateHospitality from '@/pages/ventures/Real-estate';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ventures/real-estate" element={<RealEstateHospitality />} />
          <Route path="/ventures/aviation" element={<Aviation />} />
          <Route path="/ventures/ephemera-foundation" element={<EphemeraFoundation />} />
          <Route path="/principals" element={<Principals />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
